<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px"
				:useAutoOptional="false" :optional="selectData.length !== 1" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px"
				:useAutoOptional="false" :optional="selectData.length !== 1" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="proExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF"
				title="导入" fontSize="14px" @getFile="Productexport" types="file"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a  class="Dowload" @click="proDowload">导入模板下载</a>
		</div>
		<!-- style="border: 1px solid blue;"  -->
		<div class="TableWidth">
			<Commontable ref="ProviderRef" @onRowClick="onRowClick" colnum="7" :tableData="tableData"
				:headerData="headerData" height="100%" @handleSelectionChange="handleSelectionChange"></Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<DialogFrom width="1020px" :title="`${from.AutoID?'编辑':'新增'}计量单位转换`" :dialogVisible="dialogVisibles"
			@cancel="cancel" @dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item , index) of fromdataadd">
					<Commondropdownlist :key="index" ref="proadd" :radio="item.radio" :minleft="item.minleft"
						:maxleft="item.maxleft" :options="item.options" :btx="item.btx" :inputdata="item.inputdata"
						:title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
						:disabled="item.disabled" :event="item.event" @prdCodeBlur="prdCodeBlur">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这些数据吗？</span>
		</Dialog>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../../components/dialog.vue'
	import Commondown from '../../../../components/common-down.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import headerData from '../headerData/headerData'
	import {
		HelperComUnit
	} from '@/api/home'

	import {
		DownTempUnitConvert,
		DeleteUnitConvert,
		ImportUnitConvert,
		GetInventoryByAddCode,
		AddUnitConvert,
		EditUnitConvert,
		GetUnitConvertInfo
	} from '@/api/newsapi'

	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			Commondown,
			CommonbtnUpLoad
		},
		props: {
			tableData: {
				type: Array,
				default: []
			},
			total: {
				type: Number,
				default: 0
			}
		},
		data: function() {
			return {
				selectData: [],
				dialogVisibles: false,
				dialogVisibledel: false,
				dialogVisiblesU8: false,
				dialogVisiblesU8d: false,
				rightboo: false,
				dwonleft: false,
				dialogVisibleEable: false,
				dialogVisiblesdrjg: false,
				tableDatadrjg: [],
				title: '',
				username: '',
				name: '',
				ptype: '',
				fromdataadd: [],
				fromdataedit: [],
				headerData: [],
				invCode: "",
				invAddCode: "",
				invName: "",
				invClass: "",
				from: {
					AutoID: "",
					InvCode: "",
					FUnitCode: "",
					ConvertRate: "",
				},
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false
				},
			}
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.headerData = JSON.parse(JSON.stringify(headerData))

			let data = JSON.parse(localStorage.getItem("MenusData"))
			let MenuID = this.$route.query.MenuID
			//console.log(data.Menus[0].Nodes[1], "data")
			data.Menus[0].Nodes.map((item, index) => {
				if (item.NodeID == 34) {
					item.Nodes.map((items, indexs) => {
						if (items.NodeID == 169) {
							this.qus = items.Nodes
						}
					})
				}
				// console.log(this.qus, 'this.qus');
			})
			if (this.qus) {
				this.qus.map((item, index) => {
					if (item.NodeName == 'add') {
						this.qx.add = true
					} else if (item.NodeName == 'edit') {
						this.qx.update = true
					} else if (item.NodeName == 'delete') {
						this.qx.del = true
					} else if (item.NodeName == 'stopif') {
						this.qx.del = true
					} else if (item.NodeName == 'assignment') {
						this.qx.assignment = true
					} else if (item.NodeName == 'enabled') {
						this.qx.enabled = true
					} else if (item.NodeName == 'skip') {
						this.qx.skip = true
					} else if (item.NodeName == 'reset') {
						this.qx.reset = true
					} else if (item.NodeName == 'setting') {
						this.qx.setting = true
					}
				})
			}
			//console.log("qux", this.qus)
		},
		methods: {
			getSingleSelectedRow(actionName) {
				if (this.selectData.length !== 1) {
					this.$message.warning(`请勾选一条数据进行${actionName}！`)
					return null
				}
				return this.selectData[0]
			},
			// 新增
			async inventoryAdd() {
				let {
					code,
					message
				} = await AddUnitConvert({
					InvCode: this.from.InvCode,
					FUnitCode: this.from.FUnitCode,
					ConvertRate: this.from.ConvertRate,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '新增成功'
					});
					this.dialogVisibles = false
					this.$parent.inventoryList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 详情
			async inventoryInfo() {
				let {
					code,
					data
				} = await GetUnitConvertInfo({
					AutoID: this.from.AutoID,
				})
				if (code == 0) {
					this.from.InvCode = data.InvCode;
					this.$refs.proadd[0].modelvalue = data.InvAddCode
					this.$refs.proadd[1].modelvalue = data.InvName
					this.$refs.proadd[2].modelvalue = data.UnitName
					this.$refs.proadd[3].modelvalue = data.FUnitCode
					this.$refs.proadd[4].modelvalue = data.ConvertRate
				}
			},
			// 修改
			async inventoryEdit(datalist) {
				let {
					code,
					message
				} = await EditUnitConvert({
					AutoID: this.from.AutoID,
					InvCode: this.from.InvCode,
					FUnitCode: this.from.FUnitCode,
					ConvertRate: this.from.ConvertRate,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '修改成功'
					});
					this.dialogVisibles = false
					this.$parent.inventoryList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			adduser() {
				this.from = {
					AutoID: "",
					InvCode: "",
					FUnitCode: "",
					ConvertRate: "",
				};
				this.helperComUnit();
				this.dialogVisibles = true
			},
			cancel() {
				this.$refs.proadd[0].modelvalue = "";
				this.$refs.proadd[1].modelvalue = "";
				this.$refs.proadd[2].modelvalue = "";
				this.$refs.proadd[3].modelvalue = "";
				this.$refs.proadd[4].modelvalue = "";
				this.dialogVisibles = false
			},
			onRowClick(val) {
				this.from.AutoID = val.AutoID
			},
			update() {
				const row = this.getSingleSelectedRow('修改')
				if (!row) return
				this.from.AutoID = row.AutoID
				this.helperComUnit();
				this.inventoryInfo();
				this.dialogVisibles = true
			},
			dialogOK() {
				this.from.InvAddCode = this.$refs.proadd[0].modelvalue
				this.from.InvName = this.$refs.proadd[1].modelvalue
				this.from.UnitName = this.$refs.proadd[2].modelvalue
				this.from.FUnitCode = this.$refs.proadd[3].modelvalue
				this.from.ConvertRate = this.$refs.proadd[4].modelvalue
				this.from.AutoID ? this.inventoryEdit() : this.inventoryAdd()
			},
			// 计量单位下拉
			async helperComUnit() {
				let {
					data,
					code
				} = await HelperComUnit({})
				if (code == 0) {
					this.fromdataadd[3].options = []
					let arr = []
					data.map((item, index) => {
						let obj = {
							key: item.ID,
							value: item.Name
						}
						arr.push(obj)
					})
					this.fromdataadd[3].options = arr
				}
			},
			//根据产品编码查询详情
			async prdCodeBlur(e) {
				if (!e) {
					return;
				}
				let {
					data,
					code
				} = await GetInventoryByAddCode({
					InvAddCode: e
				})
				if (code == 0 && data) {
					this.from.InvCode = data.InvCode;
					this.$refs.proadd[1].modelvalue = data.InvName
					this.$refs.proadd[2].modelvalue = data.UnitName
				}
			},
			// 产品导入,
			async Productexport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await ImportUnitConvert(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						this.$parent.inventoryList()
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
						this.$message({
							type: 'error',
							message: res.message
						})
					}
					loading.close();
				}
			},
			//下载导入模板
			async proDowload() {
				let {
					data,
					code,
					message
				} = await DownTempUnitConvert({})

				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			//复选框选中
			handleSelectionChange(e) {
				this.selectData = e;
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.inventoryDelete()
				this.dialogVisibledel = false
			},
			del() {
				const row = this.getSingleSelectedRow('删除')
				if (!row) return
				this.selectData = [row]
				this.dialogVisibledel = true
			},
			// 删除
			async inventoryDelete() {
				let {
					code,
					message
				} = await DeleteUnitConvert({
					AutoIDs: this.selectData.map(it => it.AutoID),
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.selectData = [];
					this.$parent.inventoryList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			//导出
			proExport() {
				this.$emit('proExport')
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			}
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>
